/**
 * Methods to reset entities
 */
import uuid from "uuid/v4";

const BASE_ENTITY = Object.freeze({
  name: "",
  desc: ""
});

const VERA_COVER_ENTITY = Object.freeze({ ...BASE_ENTITY, base64Cover: "" });

export default {
  BOOK: () => {
    return {
      id: uuid(),
      bookPackages: [],
      chapters: [],
      skills: [],
      topics: [],
      competenceModules: [],
      schoolTypes: [{ id: "" }],
      subjects: [],
      typeCompetenceModuleMapping: {},
      typeSubjectMapping: {},
      filter: [],
      pagebreaksPerTask: true,
      ...VERA_COVER_ENTITY
    };
  },
  BOOK_PACKAGE: () => {
    return {
      id: uuid(),
      chapters: [],
      veritasId: "",
      demo: false,
      demoWithoutLogin: false,
      imprint: "",
      imprintFileName: "",
      ...BASE_ENTITY
    };
  },
  CHAPTER: () => {
    return { id: uuid(), bookPackages: [], ...BASE_ENTITY };
  },
  COMPETENCE_MODULE: () => {
    return { id: uuid(), schoolTypes: [], ...BASE_ENTITY };
  },
  SCHOOL_SUBJECT: () => {
    return { id: uuid(), schoolTypes: [], ...BASE_ENTITY };
  },
  SCHOOL_TYPE: () => {
    return {
      id: uuid(),
      competenceModules: [],
      schoolSubjects: [],
      ...BASE_ENTITY
    };
  },
  SKILL: () => {
    return { id: uuid(), subskills: [], ...BASE_ENTITY };
  },
  TASK: () => {
    return {
      id: uuid(),
      chapter: {},
      book: {
        skills: []
      },
      bookPackage: {},
      contentTypeToFileMapping: {},
      topic: {},
      schoolSubjects: [],
      schoolTypes: [],
      taskType: {},
      gersNiveau: "",
      durationMin: 0,
      durationMax: 0,
      score: 0,
      skills: [],
      readyForStage: false,
      readyForProduction: false,
      deployedToStaging: false,
      deployedToProduction: false,
      deployedToProductionAndModified: false,
      exercise: {},
      solution: {},
      files: [],
      filterMapping: {},
      ...BASE_ENTITY
    };
  },
  TASK_TYPE: () => {
    return { id: uuid(), ...BASE_ENTITY };
  },
  TOPIC: () => {
    return { id: uuid(), ...BASE_ENTITY };
  },
  FILTER: () => {
    return {
      id: uuid(),
      veraFilterType: "LIST",
      criteria: [],
      placeholder: "",
      ...BASE_ENTITY
    };
  },
  CONTENT_TYPE: () => {
    return {
      id: uuid(),
      endings: [],
      ...BASE_ENTITY
    };
  }
};
